import { render } from "./DestinationManagement.vue?vue&type=template&id=5165ca87"
import script from "./DestinationManagement.vue?vue&type=script&lang=js"
export * from "./DestinationManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__